{
  "REPORT": {
    "HEADER": "Samtöl",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "Við höfum ekki fengið nógu marga gagnapunkta til að búa til skýrslu, vinsamlegast reyndu aftur síðar.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtöl",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Fyrsti viðbragðstími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Lausnartími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Í dag",
      "YESTERDAY": "Í gær",
      "LAST_7_DAYS": "Síðustu 7 daga",
      "LAST_30_DAYS": "Síðustu 30 daga",
      "THIS_MONTH": "Þessi mánuður",
      "LAST_MONTH": "Síðasti mánuður",
      "LAST_3_MONTHS": "Síðustu 3 mánuði",
      "LAST_6_MONTHS": "Síðustu 6 mánuði",
      "LAST_YEAR": "Síðasta ár",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Dagur",
      "WEEK": "Vika",
      "MONTH": "Mánuður",
      "YEAR": "Ár"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dagur"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dagur"
      },
      {
        "id": 2,
        "groupBy": "Vika"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dagur"
      },
      {
        "id": 2,
        "groupBy": "Vika"
      },
      {
        "id": 3,
        "groupBy": "Mánuður"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dagur"
      },
      {
        "id": 2,
        "groupBy": "Vika"
      },
      {
        "id": 3,
        "groupBy": "Mánuður"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Engar niðurstöður fundust"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Samtöl: {count}",
      "RESULT_COUNT_MESSAGE": "Skilaboð: {count}",
      "EMPTY": "Engar færslur fundust fyrir þessa súlu.",
      "ERROR": "Ekki tókst að hlaða færslum. Reyndu aftur.",
      "LOAD_MORE": "Hlaða fleiri",
      "PREVIOUS_BUCKET": "Fyrri súla",
      "NEXT_BUCKET": "Næsta súla",
      "UNKNOWN_CONTACT": "Óþekktur tengiliður",
      "UNKNOWN_INBOX": "Óþekkt innhólf",
      "UNASSIGNED_AGENT": "Óúthlutað",
      "NO_MESSAGE_CONTENT": "Ekkert efni í skilaboðum",
      "MESSAGE_CREATED_AT": "Skilaboð búin til {time}",
      "EVENT_OCCURRED_AT": "Atburður átti sér stað {time}",
      "INCOMING_MESSAGE": "Móttekin skilaboð",
      "OUTGOING_MESSAGE": "Send skilaboð",
      "VIEW_ALL": "Skoða í samtölum",
      "VIEW_ALL_LIMIT": "Aðeins súlur með að hámarki {limit} samtöl opnast í samtalalistanum.",
      "HIDDEN_COUNT": "Ekki sýnt því þú ert ekki meðlimur í innhólfi þeirra: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "Við höfum ekki fengið nógu marga gagnapunkta til að búa til skýrslu, vinsamlegast reyndu aftur síðar.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "FILTER_DROPDOWN_LABEL": "Veldu Þjónustufulltrúa",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtöl",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Fyrsti viðbragðstími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Lausnartími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Síðustu 7 daga"
      },
      {
        "id": 1,
        "name": "Síðustu 30 daga"
      },
      {
        "id": 2,
        "name": "Síðustu 3 mánuði"
      },
      {
        "id": 3,
        "name": "Síðustu 6 mánuði"
      },
      {
        "id": 4,
        "name": "Síðasta ár"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Fylgstu með frammistöðu merkja með lykilmælikvörðum, þar á meðal samtölum, svartíma, úrlausnartíma og leystum málum.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "Við höfum ekki fengið nógu marga gagnapunkta til að búa til skýrslu, vinsamlegast reyndu aftur síðar.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtöl",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Fyrsti viðbragðstími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Lausnartími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Síðustu 7 daga"
      },
      {
        "id": 1,
        "name": "Síðustu 30 daga"
      },
      {
        "id": 2,
        "name": "Síðustu 3 mánuði"
      },
      {
        "id": 3,
        "name": "Síðustu 6 mánuði"
      },
      {
        "id": 4,
        "name": "Síðasta ár"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "Við höfum ekki fengið nógu marga gagnapunkta til að búa til skýrslu, vinsamlegast reyndu aftur síðar.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtöl",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Fyrsti viðbragðstími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Lausnartími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Síðustu 7 daga"
      },
      {
        "id": 1,
        "name": "Síðustu 30 daga"
      },
      {
        "id": 2,
        "name": "Síðustu 3 mánuði"
      },
      {
        "id": 3,
        "name": "Síðustu 6 mánuði"
      },
      {
        "id": 4,
        "name": "Síðasta ár"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "Við höfum ekki fengið nógu marga gagnapunkta til að búa til skýrslu, vinsamlegast reyndu aftur síðar.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtöl",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Fyrsti viðbragðstími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Heildarfjöldi samtala sem notuð eru við útreikning:",
        "TOOLTIP_TEXT": "Lausnartími er {metricValue} (byggt á {conversationCount} samtölum)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Síðustu 7 daga"
      },
      {
        "id": 1,
        "name": "Síðustu 30 daga"
      },
      {
        "id": 2,
        "name": "Síðustu 3 mánuði"
      },
      {
        "id": 3,
        "name": "Síðustu 6 mánuði"
      },
      {
        "id": 4,
        "name": "Síðasta ár"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Veldu tímabil"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "Engin svör við CSAT könnun eru fáanleg.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Rating",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Heildarfjöldi jákvæðra svara / Heildarfjöldi svara * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Heildarfjöldi svara / Heildarfjöldi sendra CSAT könnunarskilaboða * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Fjöldi samtala",
        "TOOLTIP": "Heildarfjöldi samtala með skilaboðum frá botta"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Fjöldi svara",
        "TOOLTIP": "Heildarfjöldi sendra skilaboða"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Fjöldi gervigreindarsvara",
        "TOOLTIP": "Heildarfjöldi svarskilaboða sem bottinn sendi"
      },
      "COPILOT_COUNT": {
        "LABEL": "Fjöldi undirbúinna svara",
        "TOOLTIP": "Heildarfjöldi copilot tillagna sem bottinn útbjó fyrir þjónustufulltrúa"
      },
      "SUCCESS_RATE": {
        "LABEL": "Leyst af gervigreind",
        "TOOLTIP": "Hlutfall samtala sem gervigreind leysti án þess að vísa til þjónustufulltrúa"
      },
      "RESOLVE_TIME": {
        "LABEL": "Lausnartími",
        "TOOLTIP": "Miðgildi tíma frá fyrstu skilaboðum viðskiptavinar til síðustu skilaboða botta/þjónustufulltrúa"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Ekki hópa",
      "INBOXES": "Innhólf",
      "LABELS": "Merkingar"
    },
    "GROUPED": {
      "CHART_TITLE": "Dreifing eftir hópi",
      "BACK_TO_ALL": "Sýna allt",
      "TABLE": {
        "INBOX": "Innhólf",
        "LABEL": "Merking",
        "CONVERSATIONS": "Samtöl",
        "MESSAGES": "Skilaboð",
        "MESSAGES_TOOLTIP": "Heildarfjöldi sendra skilaboða",
        "AI_MESSAGES": "Gervigreindarsvör",
        "AI_MESSAGES_TOOLTIP": "Heildarfjöldi gervigreindarsvara, ásamt fjölda jákvæðra og neikvæðra einkunna frá notendum",
        "THUMBS_UP_TOOLTIP": "Fjöldi gervigreindarsvara sem notendur gáfu jákvæða einkunn (þumall upp)",
        "THUMBS_DOWN_TOOLTIP": "Fjöldi gervigreindarsvara sem notendur gáfu neikvæða einkunn (þumall niður)",
        "PREPARED": "Undirbúin svör",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Hlutfall skilaboða þessa hóps af öllum skilaboðum",
        "BOT_RESPONSES": "Gervigreindarsvör %",
        "SUGGESTION_USED": "Notuð svör",
        "SUGGESTION_USED_TOOLTIP": "Hlutfall undirbúinna svara í þessum hópi sem þjónustufulltrúar notuðu",
        "SUGGESTION_NOT_USED": "Ónotuð svör",
        "SUGGESTION_NOT_USED_TOOLTIP": "Hlutfall skilaboða í þessum hópi sem höfðu undirbúið svar en það var ekki notað"
      },
      "NOTES": {
        "TITLE": "Hvernig mælikvarðar eru reiknaðir",
        "CONVERSATIONS": "Fjöldi samtala sem hafa að minnsta kosti ein send skilaboð á völdu tímabili.",
        "MESSAGES": "Heildarfjöldi sendra (ekki einka) skilaboða á völdu tímabili. Þetta nær bæði yfir skilaboð frá gervigreind og skilaboð skrifuð af fólki.",
        "PERCENTAGE": "Hlutfall skilaboða þessa hóps af öllum sendum skilaboðum allra hópa.",
        "AI_MESSAGES": "Fjöldi sendra skilaboða sem gervigreindarbottinn sendi sjálfkrafa (ekki meðtalin undirbúin svör fyrir þjónustufulltrúa). Tölurnar í svigum sýna hversu mörg þessara svara fengu jákvæða (þumall upp) og neikvæða (þumall niður) einkunn frá notendum.",
        "PREPARED": "Fjöldi copilot tillagna (undirbúinna svara) sem gervigreindarbottinn útbjó fyrir þjónustufulltrúa á völdu tímabili. Þetta eru einkaskilaboð sem aðeins þjónustufulltrúar sjá og teljast ekki með sendum skilaboðum, svo þessi tala þarf ekki að samsvara Skilaboð dálkinum.",
        "SUGGESTION_USED": "Hlutfall undirbúinna svara í þessum hópi sem þjónustufulltrúar notuðu. Þetta þarf ekki að samsvara fjölda Undirbúinna svara þar sem einnig geta verið meðtaldar tillögur sem urðu til á fyrri tímabilum.",
        "SUGGESTION_NOT_USED": "Hlutfall sendra skilaboða í þessum hópi þar sem copilot tillaga var til staðar en þjónustufulltrúinn svaraði án þess að nota hana. Aðeins talið þegar þjónustufulltrúinn sendi í raun svar. Þetta þarf ekki að samsvara fjölda Undirbúinna svara þar sem einnig geta verið meðtaldar tillögur sem urðu til á fyrri tímabilum."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Open",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Unassigned",
      "PENDING": "Í bið"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Þjónustufulltrúi",
        "OPEN": "Opin",
        "UNATTENDED": "Unattended",
        "STATUS": "Staða"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Opin",
        "UNATTENDED": "Unattended",
        "STATUS": "Staða"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Upptekinn",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Engar niðurstöður fundust",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Label name",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Innhólf",
      "AGENTS": "Þjónustufulltrúi",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Samtal",
        "AGENT": "Þjónustufulltrúi"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Millisamtala",
    "NO_TEAM": "Ekkert teymi",
    "GROUP_BY_TEAMS": "Hópa eftir teymum",
    "INBOX": "Innhólf",
    "AGENT": "Þjónustufulltrúi",
    "TEAM": "Team",
    "LABEL": "Merki",
    "TOTAL": "Samtals",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Resolution Count",
    "CONVERSATIONS": "No. of conversations",
    "OUTGOING_CHATS": "Send spjöll",
    "OUTGOING_EMAILS": "Sendur tölvupóstur",
    "PHONE_CALLS": "Símtöl",
    "INBOUND_CALLS": "Innhringd símtöl",
    "OUTBOUND_CALLS": "Úthringd símtöl",
    "TOTAL_ACTIVITIES": "Aðgerðir samtals",
    "ONLINE_TIME": "Tími á netinu",
    "QUEUE_AVAILABLE_TIME": "Tími í boði í röð",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Fjöldi sendra skilaboða frá þessum þjónustufulltrúa",
      "OUTGOING_EMAILS": "Fjöldi sendra tölvupósta frá þessum þjónustufulltrúa",
      "PHONE_CALLS": "Heildarfjöldi símtala sem úthlutað er til þessa þjónustufulltrúa (samtals innhringd og úthringd símtöl)",
      "TOTAL_ACTIVITIES": "Heildarfjöldi aðgerða: innhringd símtöl + úthringd símtöl + send spjöll + sendur tölvupóstur",
      "INBOUND_CALLS": "Fjöldi innhringdra símtala sem úthlutað er til þessa þjónustufulltrúa",
      "OUTBOUND_CALLS": "Fjöldi úthringdra símtala sem úthlutað er til þessa þjónustufulltrúa",
      "AVG_FIRST_RESPONSE_TIME": "Meðaltími frá stofnun samtals til fyrsta svars þjónustufulltrúa í samtölum sem úthlutað er til þessa þjónustufulltrúa",
      "AVG_RESOLUTION_TIME": "Meðaltími frá stofnun samtals til lausnar í samtölum sem úthlutað er til þessa þjónustufulltrúa",
      "AVG_REPLY_TIME": "Meðaltími sem viðskiptavinir bíða milli skilaboða sinna og svars þjónustufulltrúa í samtölum sem úthlutað er til þessa þjónustufulltrúa",
      "ONLINE_TIME": "Heildartími sem þjónustufulltrúinn var á netinu eða upptekinn á völdu tímabili",
      "QUEUE_AVAILABLE_TIME": "Heildartími sem þjónustufulltrúinn var til taks í símaröðum á völdu tímabili"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Símaskýrslur",
    "DESCRIPTION": "Fylgstu með mælikvörðum símtala með ítarlegri innsýn í innhringd og úthringd símtöl, hópað eftir þjónustufulltrúa eða innhólfi fyrir ítarlega greiningu.",
    "DOWNLOAD_PHONE_REPORTS": "Sækja símaskýrslur",
    "GROUP_BY": {
      "LABEL": "Hópa eftir",
      "AGENT": "Þjónustufulltrúi",
      "INBOX": "Innhólf"
    },
    "TABLE": {
      "TOTAL_CALLS": "Samtals",
      "INBOUND_CALLS": "Innhringd",
      "OUTBOUND_CALLS": "Úthringd",
      "FAILED_OUTBOUND_CALLS": "Mistókst úthringd",
      "AVG_AGENT_HANDLED_DURATION": "Meðallengd",
      "TOTAL_AGENT_HANDLED_DURATION": "Heildarlengd",
      "AVG_RINGING_TIME": "Meðal hringitími",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Árangur %",
      "UNIQUE_CALLERS": "Einstakir hringjendur",
      "UNIQUE_CALLED_CONTACTS": "Einstakir hringdir",
      "UNANSWERED_MISSED_CALLS": "Ósvarað án eftirfylgni",
      "UNANSWERED_MISSED_PERCENTAGE": "Ósvarað %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Ósvarað án eftirfylgni, ófullnægjandi endurhringing",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Ósvarað án eftirfylgni, ófullnægjandi endurhringing %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Heildarfjöldi allra símtala (þar með talin ótengd)",
      "INBOUND_CALLS": "Fjöldi tengdra símtala",
      "OUTBOUND_CALLS": "Fjöldi allra úthringdra símtala (þar með talin ótengd)",
      "FAILED_OUTBOUND_CALLS": "Fjöldi úthringdra símtala sem tókst ekki að tengja",
      "AVG_AGENT_HANDLED_DURATION": "Meðallengd símtala sem þjónustufulltrúar afgreiddu",
      "TOTAL_AGENT_HANDLED_DURATION": "Heildarlengd allra símtala sem þjónustufulltrúar afgreiddu",
      "AVG_RINGING_TIME": "Meðaltími sem símtöl hringdu áður en svarað var",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Hlutfall úthringdra símtala sem tengdust með góðum árangri",
      "UNIQUE_CALLERS": "Fjöldi einstakra tengiliða sem hringdu inn",
      "UNIQUE_CALLED_CONTACTS": "Fjöldi einstakra tengiliða sem hringt var í með úthringingu",
      "UNANSWERED_MISSED_CALLS": "Fjöldi ósvaraðra símtala þar sem ekki tókst endurhringing (símtal tengt). Getur innihaldið símtöl sem enn má afgreiða innan vinnudagsins",
      "UNANSWERED_MISSED_PERCENTAGE": "Hlutfall einstakra hringjenda sem símtöl féllu niður án eftirfylgni (ósvarað án eftirfylgni / einstakir hringjendur)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Fjöldi ósvaraðra símtala með færri en 2 endurhringitilraunum. Getur innihaldið símtöl sem enn má afgreiða innan vinnudagsins",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Hlutfall einstakra hringjenda með færri en 2 endurhringitilraunum ((ósvarað án eftirfylgni − nægilega afgreitt) / einstakir hringjendur)"
    }
  }
}
